import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import useAccounts from '../../hooks/useAccounts';
import { useGetServiceProductOrCategoriesQuery } from '../../services/dashboardService';
import { FullPageWrapper } from '../custom/IndividualMappingLayout';
import amIVisible from '../../componentControl/registry';
import { useEffect, useState } from 'react';

export const IndividualServiceProductMapping = ({ formik }) => {

    const { t } = useTranslation()

    const [isLoadingAccounts, accountsList] = useAccounts('items');

    const { currentSw } = useSelector(state => state.dashboard)

    const { serviceItems } = formik.values;

    const { serviceProductLabels } = useSelector(state => state.dashboard)

    const [isEmptyLabels, setIfEmptyLabels] = useState(false)

    const { isLoading, isFetching, refetch } = useGetServiceProductOrCategoriesQuery({
        recordItems: true,
        serviceItems: true,
        serviceCategory: false
    }, {
        skip: false,
        selectFromResult: ({ data, ...rest }) => {
            let labels = data?.map((item) => {
                return {
                    label: item.name,
                    value: item.id
                }
            })

            labels = _.filter(labels, item => {
                return !_.keys(_.pickBy(serviceItems, (items) => items !== '')).includes(item?.value + '')
            })
     
            return {
                data: labels,
                ...rest
            }
        }
    })

    useEffect(() => {
        setIfEmptyLabels(serviceProductLabels?.length === 0)
    }, [serviceProductLabels])

    useEffect(() => {

        const labels = serviceProductLabels ?? []

        if (labels?.length === 0 && !isEmptyLabels) {
            refetch()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceProductLabels])

    const isDynamicMapping = amIVisible("enter field for product and categories individual")

    return (
        <>
            <FullPageWrapper
                title={t('Map Services')}
                fullPageDesp={t(`Individual services can be mapped to unique accounts in ${currentSw}. All unassigned and new services will be assigned to the default services account.`, { swName: currentSw })}
                formik={formik}
                formikFieldName={"serviceItemsMapping"}
                isLoading={isLoading || isFetching}
                isAccountsLoading={isLoadingAccounts}
                heading={"Services"}
                isDynamicMapping={isDynamicMapping}
                options={accountsList}
                labelOption={serviceProductLabels}
                advanceMapping
                rowLoaderProps={{
                    box: true,
                    rows: 10
                }}
            />
        </>
    )
}